<template>
  <div class="registry-request-grid">
    <vt-side-panel
      :visible="showSidePanel"
      :loading="loadingRequestDetail"
    >
      <common-request-detail
        v-if="selectedRegistryRequest"
        :study-request="selectedRegistryRequest"
        :cas-id="reqCasId"
        :tracking-resource="trackingResource"
        class="study-request-buttons"
        :tab-index="tabIndex"
        @tabIndex="tabIndex = $event"
      >
        <template slot="buttons-end">
          <b-button
            v-if="$_canCreateIncident()"
            v-tooltip="$t('hoverBtn.registerIncident')"
            qa="registry-request-grid-register-incident-button"
            class="btn__icon btn__icon--primary px-2 py-0"
            variant="primary"
            :disabled="!$_canBeIncidentCreatedToRequest(request)"
            @click="incidentModal(request)"
          >
            <i
              class="far fa-file-alt"
              aria-hidden="true"
            />
          </b-button>

          <b-button
            v-tooltip="$t('hoverBtn.seeIncidence')"
            qa="registry-request-grid-incidents-button"
            class="btn__icon btn__icon--primary px-2 py-0"
            variant="primary"
            @click="viewIncident(request)"
          >
            <i
              class="far fa-exclamation-triangle"
              aria-hidden="true"
            />
          </b-button>

          <b-button
            v-if="$_canProcessRequest(request)"
            v-tooltip="$t('hoverBtn.processRequest')"
            qa="registry-request-grid-process-request-button"
            class="btn__icon btn__icon--primary px-2 py-0"
            variant="primary"
            @click="processValidation(request)"
          >
            <i
              class="far fa-check-circle"
              aria-hidden="true"
            />
          </b-button>

          <b-button
            v-if="$_canCancelRequest()"
            v-tooltip="$t('hoverBtn.cancelRequest')"
            qa="registry-request-grid-cancel-request-button"
            class="btn__icon btn__icon--primary px-2 py-0"
            variant="primary"
            :disabled="htmlDisabledSelectedRequestCancelButton"
            @click="cancelModal()"
          >
            <i
              class="far fa-ban"
              aria-hidden="true"
            />
          </b-button>

          <b-button
            v-if="$_canPrintRequestReport()"
            v-tooltip="$t('hoverBtn.printRequest')"
            qa="registry-request-grid-print-request-report-button"
            class="btn__icon btn__icon--primary px-2 py-0"
            variant="primary"
            @click="printRequestReport()"
          >
            <i
              class="far fa-print"
              aria-hidden="true"
            />
          </b-button>

          <b-button
            v-if="request.status.code === REQUEST_STATES.REGISTERED.code"
            v-tooltip="$t('hoverBtn.printTags')"
            qa="registry-request-grid-print-subrequest-labels-button"
            class="btn__icon btn__icon--primary px-2 py-0"
            variant="primary"
            @click="printSubrequestLabels()"
          >
            <i
              class="far fa-ticket-alt"
              aria-hidden="true"
            />
          </b-button>

          <b-button
            v-if="request.status.code === REQUEST_STATES.RETURNED.code"
            id="requestDetailPrint"
            v-tooltip="$t('hoverBtn.printReport')"
            qa="registry-request-grid-print-report-button"
            class="btn__icon btn__icon--primary px-2 py-0"
            variant="primary"
          >
            <i
              class="far fa-file-import"
              aria-hidden="true"
            />
          </b-button>

          <b-button
            v-if="hideBtn"
            id="requestDetailSpecialMenu"
            qa="registry-request-grid-ellipsis-button"
            class="btn__icon btn__icon--primary px-2 py-0 ellipsis"
            variant="primary"
          >
            <i
              class="far fa-ellipsis-v"
              aria-hidden="true"
            />
          </b-button>

          <b-button
            id="requestsSidePanelClose"
            v-shortkey="['shift', 'esc']"
            qa="registry-request-grid-close-sidepanel-button"
            class="btn__icon btn__icon--primary pl-2 py-0"
            @shortkey.prevent="showSidePanel = false"
            @click="showSidePanel = false"
          >
            <i
              class="fal fa-times"
              aria-hidden="true"
            />
          </b-button>
        </template>
      </common-request-detail>
    </vt-side-panel>
    <b-row class="search-block mb-3 mt-1">
      <b-col
        xl="4"
        lg="6"
        md="6"
        sm="6"
      >
        <searcher-module-entity-selection
          :identifier-options="entitySelectorOptionsForSearch"
          :initial-identifier="entitySelectorOptionsForSearch[0]"
          @studySearch="studySearch"
          @requestSearch="requestSearch"
          @subrequestSearch="subrequestSearch"
          @insuranceNumberSearch="onInsuranceNumberSearch"
        />
      </b-col>
      <b-col
        xl="8"
        lg="6"
        md="6"
        sm="6"
        class="text-right"
      >
        <div style="margin-top: 5px;">
          <b-button
            v-shortkey="['f10']"
            qa="registry-request-grid-patients-button"
            class="btn__link px-3"
            @shortkey.prevent="openPatientModal"
            @click="openPatientModal"
          >
            <i
              class="far fa-users mr-2"
              aria-hidden="true"
            />{{ $tc('global.patients') }}
          </b-button>
          <!-- TODO: A petición de Javier, se oculta el siguiente botón con la clase "d-none" hasta darle uso en el futuro -->
          <b-button
            v-if="hasRequestActive"
            id="requestsRouteToStudyRequestCreate"
            class="d-none ml-2 btn btn--primary btn-secondary btn-sm"
          >
            <fa-icon
              class="mr-1"
              :icon="['fal', 'plus']"
            />
            {{ $tc('global.request',1) }}
          </b-button>
        </div>
      </b-col>
    </b-row>
    <div class="grid-container">
      <GridHeader
        v-if="sideBarState.selectedOption"
        :gridtitle="sideBarState.selectedOption ? $t(sideBarState.selectedOption.label) : ''"
        :gridsubtitle="msgSelectedRows"
        :qa="sideBarState.selectedOption.id"
      >
        <grid-display-options
          v-if="gridApi"
          :ui-component="displayOptionsUiComponent"
          @changedPageSize="changedPageSize($event)"
          @changedMode="changedMode($event)"
        />
        <div class="pl-1 pr-0 d-flex align-items-center">
          <b-button
            id="samplesCleanFilters"
            v-tooltip="$t('global.cleanFilter')"
            v-shortkey="['ctrl', 'alt', 'f']"
            qa="registry-request-grid-clean-button"
            class="btn__icon btn__icon--primary mx-1"
            @shortkey.prevent="cleanFilters"
            @click="cleanFilters"
          >
            <i
              class="far fa-filter"
              aria-hidden="true"
            />
          </b-button>
        </div>

        <vt-report-export-buttons
          source="registry-request-grid"
          :export-report="exportReport"
        />
      </GridHeader>
      <vt-grid
        ref="vtGrid"
        class="registry-request-grid"
        qa="registry-request-grid"
        :short-key="shortKey"
        :grid-options="gridOptions"
        :column-defs="columnDefs"
        :master-detail="true"
        :component-code="gridUiComponent"
        :use-detail-custom-config="true"
        :framework-components="frameworkComponents"
        :detail-cell-renderer="detailCellRenderer"
        :detail-cell-renderer-params="detailCellRendererParams"
      />
    </div>
    <modal-wrapper ref="incidentFormModal">
      <incident-form-modal
        id="incidentFormModal"
        core-entity="REQUEST"
        @incident-added="onIncidentListUpdated"
      />
    </modal-wrapper>
    <modal-wrapper ref="addFilterModal">
      <add-custom-filter-modal
        id="addFilterModal"
        @ok="onAddFilterOk"
      />
    </modal-wrapper>
    <modal-wrapper ref="confirmationModalCheckable">
      <modal-confirmation-checkable
        id="registryRequestGridConfirmationModalCheckable"
        :name="nameModal"
        :store-name="storeNameModal"
        :content="messageModal"
        :ui-component="uiComponentModal"
      />
    </modal-wrapper>
    <modal-wrapper ref="incidentModalTreeWrapper">
      <common-incident-modal-tree
        :is-request="true"
        @incident-added="onIncidentListUpdated"
        @incident-closed="onIncidentListUpdated"
      />
    </modal-wrapper>
    <modal-wrapper ref="searchPatientModal">
      <search-patient-modal id-modal="searchPatientModal" />
    </modal-wrapper>
    <print-component ref="printComponent" />
    <modal-wrapper ref="patientSelectionModalWrapper">
      <patient-selection-modal
        id="patientSelectionModal"
        @continue="processModal()"
      />
    </modal-wrapper>
    <request-transfer-modal
      ref="requestTransferModal"
      @change-request-laboratory-ok="onChangeRequestLaboratory"
    />
  </div>
</template>

<script>
import CommonIncidentModalTree from '@/components/incidentsModal/CommonIncidentModalTree'
import Encoder from '@/utils/encoder'
import ModalConfirmationCheckable from '@/components/modals/ModalConfirmationCheckable'
import VtGrid from '@/components/VtGrid/VtGrid'
import GridHeader from '@/components/GridHeader'
import { registryRequestGridColumnDefs } from '@/modules/RegistryModule/views/requestGrid/config/registry-request-grid.column-defs'
import { RegistryRequestGridDatasource } from '@/modules/RegistryModule/views/requestGrid/config/registry-request-grid-datasource'
import RegistryRequestResource from '@/modules/RegistryModule/services/registryRequestResource'
import { registryRequestPrintService } from '@/modules/printModule/services/RegistryRequestPrintService'
import { StoreUtils } from '@/shared/util/store-utils'
import gridSideBarConfig from '@/grid/gridSideBarConfig'
import registryRequestContextMenu from './config/registryRequestGridContextMenu'
import registrySideBarStore from '../../sideBar/request/registryRequestSideBarStore'
import detailCellRendererForm from './config/detailCellRenderer.vue'
import incidentFormModal from '@/components/incidentsModal/IncidentFormModal'
import CommonRequestDetail from '@/components/common/detail/CommonRequestDetail'
import AddCustomFilterModal from '@/components/customFilter/AddCustomFilterModal'
import customFilterResource from '@/api/resources/ui/CustomFilterResource'
import entityIds from '@/utils/coreEntityIds'
import { isEmpty } from 'lodash'
import SearchPatientModal from '@/components/searcherPatientModal/SearchPatientModal'
import commonRequestService from '@/api/resources/common/commonRequestService'
import { REQUEST_STATES } from '@/api/resources/entityState/request-state'
import { INSURANCE_NUMBER } from '@/api/resources/identifierScopesResource'
import { IdentifierTypeScope } from '@/api/resources/common/initialization/common-initialization.dto'
import GridDisplayOptions from '@/components/GridDisplayOptions'
import SearcherModuleEntitySelection from '@/components/SearcherModuleEntitySelection'
import patientDiscrepancyServices from '@/api/resources/patientDiscrepancyServices'
import { RequestOperation } from '@/api/operations/models/request-operation'
import { CaseOperation } from '@/api/operations/models/case-operation'
import { RequestOperationGuardMixin } from '@/api/operations/mixins/guards/request-operation-guard.mixin'
import { IncidentOperationGuardMixin } from '@/api/operations/mixins/guards/incident-operation-guard.mixin'
import { GridExportMixin } from '@/mixins/grid-export.mixin'
import incidentServices from '@/api/resources/incident/incidentServices'
import PatientSelectionModal from '@/modules/RegistryModule/components/patientDiscrepancyModal/PatientSelectionModal'
import { GridUtils } from '@/shared/util/grid-utils'
import { HelperUtils } from '@/shared/util/helper-utils'
import RequestTransferModal from './request-transfer-modal/request-transfer-modal.vue'
import { router } from '@/router'

export default {
    name: 'RegistryRequestGrid',
    components: {
        ModalConfirmationCheckable,
        VtGrid,
        GridHeader,
        incidentFormModal,
        CommonRequestDetail,
        AddCustomFilterModal,
        CommonIncidentModalTree,
        SearchPatientModal,
        GridDisplayOptions,
        SearcherModuleEntitySelection,
        PatientSelectionModal,
        RequestTransferModal
    },
    mixins: [
        RequestOperationGuardMixin,
        IncidentOperationGuardMixin,
        GridExportMixin
    ],
    data() {
        return {
            pageSize: 20,
            mode: { value: 'compact', icon: 'fal fa-align-justify' },
            gridUiComponent: 'uicomponent.registry.filter.requests',
            displayOptionsUiComponent: 'uicomponent.registry.requestgrid',
            tabIndex: 0,
            delayDoubleClick: 200,
            REQUEST_STATES: REQUEST_STATES,
            preventClick: false,
            nameModal: null,
            storeNameModal: 'registryModalsState',
            uiComponentModal: 'uicomponent.registry.modalconfig',
            search: null,
            patId: null,
            loadingRequestDetail: false,
            hideBtn: false,
            initFilterModel: null,
            loadIncidenceForm: false,
            request: null,
            messageModal: '',
            reqCasId: null,
            showSidePanel: false,
            encoder: new Encoder(),
            selectedRegistryRequest: null,
            detailCellRenderer: 'detailCellRenderer',
            frameworkComponents: { detailCellRenderer: detailCellRendererForm },
            columnDefs: registryRequestGridColumnDefs(
                this.onIdCellClicked,
                this.onIncidentsClicked
            ),
            gridApi: null,
            sideBarState: registrySideBarStore.state,
            validationRegex: [],
            columnApi: null,
            selectedRows: [],
            shortKey: {
                keys: { process: ['ctrl', 'enter'], cancel: ['alt', 'del'], print: ['alt', 'p'] },
                callFn: this.shortcutsActions
            }
        }
    },
    computed: {
        htmlDisabledSelectedRequestCancelButton() {
            return !this.request || !this.request.metadata.operationGuards.canBeCancelled
        },
        entitySelectorOptionsForSearch() {
            return [{ scopes: [IdentifierTypeScope.REQUEST, IdentifierTypeScope.SUBREQUEST], icon: 'fal fa-file-medical', text: this.$tc('registry.searcher.requestOrSamples'), errorMessage: this.$tc('registry.errors.validIdentifierRequest') },
                { scopes: [IdentifierTypeScope.CASE], icon: 'fal fa-chart-network', text: this.$tc('global.case'), errorMessage: this.$tc('registry.errors.validIdentifierCase') },
                { id: INSURANCE_NUMBER, icon: 'far fa-file-alt', text: this.$tc('global.insurancePolicy') }]
        },
        hasCanisterTracking() {
            const activeModule =
                StoreUtils.selectedLaboratoryConfiguration?.activeModules.find(
                    module => module.moduleCode === 'configuration.parameter.laboratory.module.registry.canisterTracking.active')
            return !!activeModule?.activeStatus
        },
        msgSelectedRows() {
            if (this.selectedRows.length) {
                const choice = this.selectedRows.length > 1 ? 2 : 1
                return `${this.selectedRows.length} ${this.$tc('global.selectedElements', choice)}`
            }
            return ''
        },
        hasRequestActive() {
            const activeModule =
                StoreUtils.selectedLaboratoryConfiguration?.activeModules.find(
                    module => module.moduleCode === 'configuration.parameter.laboratory.module.registry.request.active')
            return !!activeModule?.activeStatus &&
                this.$_hasLabOperation(this.laboratoryId, 'operation.entity.request.create')
        },
        gridOptions() {
            return {
                onGridReady: this.onGridReady,
                onSelectionChanged: this.onSelectionChanged,
                paginationPageSize: this.pageSize,
                getRowHeight: this.rowHeight,
                paginationAutoPageSize: false,
                getContextMenuItems: this.getContextMenuItems,
                onRowDoubleClicked: this.onRowDoubleClicked,
                sideBar: gridSideBarConfig,
                onSortChanged: ({ api }) => api.deselectAll(),
                onFilterChanged: ({ api }) => api.deselectAll(),
                autoGroupColumnDef: {
                    headerName: 'Consoles', // custom header name for group
                    pinned: 'left', // force pinned left. Does not work in columnDef
                    cellRendererParams: {
                        suppressCount: true // remove number in Group Column
                    }
                }
            }
        },
        detailCellRendererParams() {
            return {
                detailGridOptions: {
                    detailRowHeight: 600,
                    suppressContextMenu: true
                }
            }
        },
        entityRequestId() {
            let requestElement = entityIds.find(ids => ids.name === 'REQUEST')
            return requestElement.name
        },
        laboratoryId() {
            return this.$store.getters.labId
        },
        sideBarFilterModel() {
            if (!this.sideBarState.selectedOption) {
                return {}
            }
            return this.sideBarState.selectedOption.filterModel
        },
        sideBar() {
            // changes when the sideBar is expanded or contracted
            return this.sideBarState.sideBar
        },
        trackingResource() {
            // TODO para Jesús: Revisar la parte del tracking. Hay dos componentes de tracking
            if (commonRequestService) {
                return commonRequestService
            }
            return {}
        },
        regex() {
            return this.$store.getters.regex
        }
    },
    watch: {
        sideBarFilterModel(newValue) {
            if (!isEmpty(newValue)) {
                this.applySideBarFilterModel()
            }
        },
        sideBar() {
            if (this.gridApi) {
                this.gridApi.sizeColumnsToFit()
            }
        }
    },
    beforeDestroy() {
        this.$eventHub.$off('showProcessModal', this.processRequest)
        this.$eventHub.$off('showIncidentModal', this.incidentModal)
        this.$eventHub.$off('showCancelModal', this.cancelModal)
        this.$eventHub.$off('showReturnModal', this.returnModal)
    },
    created() {
        this.$eventHub.$on('showProcessModal', this.processRequest)
        this.$eventHub.$on('showIncidentModal', this.incidentModal)
        this.$eventHub.$on('showCancelModal', this.cancelModal)
        this.$eventHub.$on('showReturnModal', this.returnModal)
    },
    mounted() {
        if (this.$route.params.filterModel) {
            this.initFilterModel = this.$route.params.filterModel
        }
        this.validationRegex = this.regex.filter(reg => reg.identifierType.idtScope === IdentifierTypeScope.PERSON ||
                    reg.identifierType.idtScope === 'CASE' || reg.identifierType.idtScope === IdentifierTypeScope.REQUEST)
    },
    methods: {
        showRequestTransferModal() {
            this.$refs.requestTransferModal.show()
        },
        showInGlobalLocator(label) {
            this.$eventHub.$emit('show-in-global-locator', label)
        },
        onSelectionChanged({ api }) {
            this.selectedRows = api.getSelectedRows()
        },
        async onRowDoubleClicked({ data }) {
            let params = {
                id: data.id
            }
            if (data.caseStudy) params.casId = data.caseStudy.casId
            this.preventClick = true
            await router.push({ name: 'viewRequest', params: params })
        },
        openPatientModal() {
            this.$refs.searchPatientModal.show()
        },
        async shortcutsActions(event) {
            if (this.selectedRows.length === 1) {
                const selectedRow = this.selectedRows[0]
                switch (event.srcKey) {
                case 'process':
                    await this.processValidation(selectedRow)
                    break
                case 'cancel':
                    this.cancelModal(selectedRow)
                    break
                case 'print':
                    await this.printRequestReport(selectedRow)
                    break
                }
            }
        },
        viewIncident(params) {
            let defaultOption = {
                coreEntity: 'REQUEST',
                requestId: params.id
            }
            this.$refs.incidentModalTreeWrapper.show([defaultOption, params.patient.id])
        },
        rowHeight(params) {
            if (params?.node && params?.node.detail) {
                return 280
            } else {
                if (this.mode.value === 'compact') {
                    return 25
                }
                return 40
            }
        },
        onIncidentListUpdated() {
            this.$emit('updateSummary')
            this.showSidePanel = false
            this.reloadRowData()
        },
        reloadRowData() {
            this.gridApi.deselectAll()
            this.gridApi.setServerSideDatasource(new RegistryRequestGridDatasource(this.laboratoryId))
        },
        cleanFilters() {
            this.applySideBarFilterModel()
        },
        changedMode(selectedOption) {
            this.mode = selectedOption
            GridUtils.changeRowHeightGrid(this.gridApi, selectedOption.size)
        },
        changedPageSize(pageSize) {
            this.pageSize = pageSize
            this.gridApi.paginationSetPageSize(pageSize)
        },
        clearSearch() {
            registrySideBarStore.selectFallbackOption()
        },
        processModal(data) {
            if (data) this.request = data
            this.nameModal = 'modalProcessConfirmation'
            if (!this.getModalConfirmationState(this.nameModal)) {
                this.messageModal = this.$t('component.modalProcess.title') + ` ${
                    this.request.label
                }?`
                this.$refs.confirmationModalCheckable.show([() => {
                    this.onProcessConfirmation()
                }])
            } else {
                this.onProcessConfirmation()
            }
        },
        async getIntegrationPatient() {
            this.updateLoading(true)
            const [error, response] = await this.toCall(patientDiscrepancyServices.getPatientWithDiscrepancy(this.labId, this.request.id))
            this.updateLoading(false)
            if (error) {
                this.showErrorModalGlobalFromErrorResponse(error)
                return
            }
            return response
        },
        async processRequest() {
            if (this.request.hasPendingDiscrepancies) {
                const integrationPatient = await this.getIntegrationPatient()
                const localPatientWithDiscrepancies = await this.getLocalPatientWithDiscrepancies()
                this.$refs.patientSelectionModalWrapper.show([localPatientWithDiscrepancies, integrationPatient, this.request.patient, this.request.id, this.request.label, this.labId])
            } else {
                this.processModal()
            }
        },
        cancelModal(data) {
            if (data) this.request = data
            this.nameModal = 'modalCancelConfirmation'
            if (!this.getModalConfirmationState(this.nameModal)) {
                this.messageModal = this.$t('component.modalCancel.title') + ` ${
                    this.request.label
                }?`
                this.$refs.confirmationModalCheckable.show([() => {
                    this.onCancelConfirmation()
                }])
            } else {
                this.onCancelConfirmation()
            }
        },
        async returnModal(printReturnForm = false) {
            this.nameModal = 'modalReturnConfirmation'
            if (!this.getModalConfirmationState(this.nameModal)) {
                this.messageModal = this.$t('component.modalReturn.title') + ` ${
                    this.request.label
                }?`
                this.$refs.confirmationModalCheckable.show([() => {
                    this.onReturnConfirmation(printReturnForm)
                }])
            } else {
                await this.onReturnConfirmation(printReturnForm)
            }
        },
        incidentModal(data) {
            this.$refs.incidentFormModal.show([null, { requestId: data.id }])
        },

        async studySearch(searchInformation) {
            const filter = {
                'caseStudy.casCasenumber': GridUtils.getTextFilterModel('equals', searchInformation)
            }
            if (searchInformation.searchType === 'currentPage') {
                Object.assign(filter, this.sideBarFilterModel)
            }
            const filterModel = this.encoder.encode(this.encoder.parseBooleans(filter))
            const response =
                await this.$_toCallUnique(
                    RegistryRequestResource.paginator(filterModel, undefined, this.laboratoryId))
            if (response) {
                if (response.content.length) {
                    registrySideBarStore.setSelectedOption(null)
                    await router.push({ name: 'viewRequest', params: { id: response.content[0].id } })
                } else {
                    this.$_showErrorModal(this.$tc('registry.requestGrid.search.noRequest'))
                }
            }
        },
        async onChangeRequestLaboratory({ id, subrequestLabel }) {
            await router.push({ name: 'viewRequest', params: { id, subrequest: subrequestLabel } })
        },
        async requestSearch(searchInformation) {
            const params = {
                requestLabel: searchInformation
            }
            const response =
                await this.$_toCallUnique(
                    RegistryRequestResource.searchByRequestLabel(this.laboratoryId, params))
            if (response?.length) {
                let entitySelected = response[0]
                if (response?.length > 1) {
                    const foundEntities =
                        response.map(entity => ({
                            entityType: IdentifierTypeScope.REQUEST,
                            entityValue: {
                                ...entity,
                                requestDate: entity.reqRequestDate
                            },
                            laboratoryId: entity.laboratory.labId
                        }))
                    entitySelected = await this.$_showMultiEntitySelection(searchInformation, foundEntities)
                }
                const isRequestInAnotherLaboratory = entitySelected.laboratory.labId !== this.$store.getters.labId
                if (isRequestInAnotherLaboratory) {
                    this.$refs.requestTransferModal.show(entitySelected)
                } else {
                    await router.push({ name: 'viewRequest', params: { id: entitySelected.id } })
                }
            } else {
                this.$_showErrorModal(this.$tc('registry.requestGrid.search.noRequest'))
            }
        },
        async subrequestSearch(searchInformation) {
            const params = {
                subrequestLabel: searchInformation
            }
            const response =
                await this.$_toCallUnique(
                    RegistryRequestResource.searchBySubrequestLabel(this.laboratoryId, params))
            if (response?.length) {
                let entitySelected = response[0]
                if (response.length > 1) {
                    const foundEntities =
                        response.map(entity => ({
                            entityType: IdentifierTypeScope.REQUEST,
                            entityValue: entity,
                            laboratoryId: entity.laboratory.labId
                        }))
                    entitySelected = await this.$_showMultiEntitySelection(searchInformation, foundEntities)
                }
                const isRequestInAnotherLaboratory = entitySelected.laboratory.labId !== this.$store.getters.labId
                if (isRequestInAnotherLaboratory) {
                    this.$refs.requestTransferModal.show(entitySelected, searchInformation)
                } else {
                    await router.push({
                        name: 'viewRequest',
                        params: {
                            id: entitySelected.id,
                            subrequest: searchInformation
                        }
                    })
                }
            } else {
                this.$_showErrorModal(this.$tc('registry.requestGrid.search.noRequest'))
            }
        },

        async onInsuranceNumberSearch(searchInformation) {
            const filter = {
                'insuranceNumber': {
                    filterType: 'text',
                    type: 'contains',
                    filter: searchInformation
                }
            }
            const encodedFilterModel = this.encoder.encode(this.encoder.parseBooleans(filter))
            const response = await this.$_toCallUnique(RegistryRequestResource.paginator(encodedFilterModel, undefined, this.laboratoryId))
            if (response?.content?.length) {
                let entitySelected = response.content[0]
                if (response.content.length > 1) {
                    this.gridApi.setFilterModel(filter)
                } else {
                    const isRequestInAnotherLaboratory = entitySelected.laboratory.labId !== this.$store.getters.labId
                    if (isRequestInAnotherLaboratory) {
                        this.$refs.requestTransferModal.show(entitySelected)
                    } else {
                        await router.push({ name: 'viewRequest', params: { id: entitySelected.id } })
                    }
                }
            } else {
                this.$_showErrorModal(this.$tc('registry.requestGrid.search.noRequest'))
            }
        },

        async onProcessConfirmation() {
            this.updateLoading(true)
            let [error, response] = await this.toCall(RegistryRequestResource.processRequest(
                this.request.laboratory.labId,
                this.request.id
            ))
            if (error) {
                this.updateLoading(false)
                this.showErrorModalGlobal()
                return
            }
            await router.push({ name: 'registryEditCase', params: { id: response.data.casId, caseData: response.data } })
        },
        async onCancelConfirmation() {
            this.updateLoading(true)
            let [error] = await this.toCall(RegistryRequestResource.cancelRequest(
                this.request.laboratory.labId,
                this.request.id
            ))
            this.$emit('updateSummary')
            if (error) {
                this.updateLoading(false)
                this.showErrorModalGlobal()
                return
            }
            if (this.showSidePanel) {
                this.showSidePanel = false
            }
            this.showSuccessModalGlobal(this.$t('studyRequest.info.requestCanceled'))
            this.applySideBarFilterModel()
            this.updateLoading(false)
        },
        async onReturnConfirmation(printReturnForm) {
            this.updateLoading(true)
            let params = {
                'entityIdentifiers': [this.request.id]
            }
            let [error] = await this.toCall(RegistryRequestResource.returnRequest(params))
            if (error) {
                this.updateLoading(false)
                this.showErrorModalGlobal()
                return
            }
            this.showSuccessModalGlobal(this.$t('registry.requestGrid.successReturn'))
            this.applySideBarFilterModel()
            this.updateLoading(false)
            if (printReturnForm) {
                await this.printReturnForm()
            }
        },
        async printReturnForm() {
            this.updateLoading(true)
            const [err, report] = await this.toCall(incidentServices.getFirstRequestIncidentReport(this.request.laboratory.labId, this.request.id))
            this.updateLoading(false)
            if (err) {
                this.showErrorModalGlobalFromErrorResponse(err)
                return
            }
            const filePDF = new Blob([report], { type: 'application/pdf' })
            const fileURL = window.URL.createObjectURL(filePDF)
            window.open(fileURL)
        },
        async changeSelectedRegistryRequest(labId, id) {
            this.loadingRequestDetail = true
            this.selectedRegistryRequest = null
            let [error, response] = await this.toCall(commonRequestService.getRequestByIdForSidePanel(
                labId,
                id
            ))
            if (error) {
                this.showErrorModalGlobal()
                this.showSidePanel = false
            }
            this.loadingRequestDetail = false
            this.selectedRegistryRequest = response
        },
        onIdCellClicked({ data: registryRequest }) {
            setTimeout(() => {
                if (!this.preventClick) {
                    this.request = registryRequest
                    this.reqCasId =
                        registryRequest &&
                        registryRequest.caseStudy &&
                        registryRequest.caseStudy.casId
                    this.changeSelectedRegistryRequest(
                        registryRequest.laboratory.labId,
                        registryRequest.id
                    )
                    this.showSidePanel = true
                }
            }, this.delayDoubleClick)
        },
        onIncidentsClicked({ data: registryRequest }) {
            setTimeout(() => {
                if (!this.preventClick) {
                    this.viewIncident(registryRequest)
                }
            }, this.delayDoubleClick)
        },
        onGridReady(api) {
            this.gridApi = api.api
            this.columnApi = api.columnApi

            this.gridApi.setColumnDefs(
                this.$_filterPatientColumns(
                    this.columnDefs,
                    'patient.middleName',
                    'patient.surname2'))

            if (this.initFilterModel) {
                this.gridApi.setFilterModel(this.initFilterModel)
                this.initFilterModel = null
            } else if (this.sideBarFilterModel) {
                this.applySideBarFilterModel()
            }

            this.gridApi.setServerSideDatasource(new RegistryRequestGridDatasource(this.laboratoryId))
        },
        getModalConfirmationState(modalName) {
            return this.$_getModalConfirmationState(this.storeNameModal, modalName)
        },
        async editCase() {
            if (this.request.caseStudy) {
                await router.push({ name: 'registryEditCase', params: { id: this.request.caseStudy.casId } })
            }
        },
        async processValidation(data) {
            if (!this.hasCanisterTracking) {
                await this.processRequest()
            } else {
                let params = {
                    id: data.id
                }
                if (data.caseStudy) params.casId = data.caseStudy.casId
                await router.push({ name: 'viewRequest', params: params })
            }
        },
        getContextMenuItems(params) {
            if (params?.node) {
                this.request = params.node.data
                const isMultipleSelection = this.selectedRows.length > 1
                return registryRequestContextMenu.getRequestedItems(params, {
                    processRequest: {
                        action: () => this.processValidation(this.request),
                        enabled: () => this.$_canProcessRequest(this.request) && !isMultipleSelection
                    },
                    editCase: {
                        action: () => this.editCase(),
                        enabled: () => this.$_canGoToCaseView(this.request.status.code)
                    },
                    cancelRequest: {
                        action: () => this.cancelModal(),
                        enabled: () => this.selectedRows.every(request => request.metadata.operationGuards.canBeCancelled)
                    },
                    createIncident: {
                        action: () => this.incidentModal(this.request),
                        enabled: () => this.$_canCreateIncident() && this.$_canBeIncidentCreatedToRequest(this.request) && !isMultipleSelection
                    },
                    returnRequest: {
                        action: () => this.returnModal(),
                        enabled: () => this.$_canReturnRequest(this.request.status.code)
                    },
                    returnAndPrint: {
                        action: () => this.returnModal(true),
                        enabled: () => this.$_canReturnRequestAndPrintReturnForm(this.request.status.code)
                    },
                    viewIncident: {
                        action: () => this.viewIncident(this.request),
                        enabled: () => !isMultipleSelection
                    },
                    viewRequest: {
                        action: () => this.onIdCellClicked(params.node),
                        enabled: () => !isMultipleSelection
                    },
                    printRequest: {
                        action: () => this.printRequestReport(this.request),
                        enabled: () => this.$_canPrintRequestReport() && this.$_canBeRequestReportPrinted(this.request) && !isMultipleSelection
                    },
                    printTag: {
                        action: async () => {
                            const subrequests = await RegistryRequestResource.getSubRequests(this.request.laboratory.labId, this.request.id)
                            const request = {
                                id: this.request.id,
                                laboratory: this.request.laboratory,
                                subrequests
                            }
                            await this.printSubrequestLabels(request)
                        },
                        enabled: () => HelperUtils.hasOperationInCurrentLaboratory(RequestOperation.PRINT) && !isMultipleSelection
                    },
                    printReturnedReport: {
                        action: () => this.printReturnForm(),
                        enabled: () => this.$_canPrintReturnForm(this.request.status.code)
                    },
                    printPathologyReport: {
                        action: () => this.printPathologyReport(
                            this.request.laboratory.labId,
                            this.request.caseStudy.casId,
                            this.request.hasCaseStudiesAssociated),
                        enabled: (request) => {
                            return REQUEST_STATES.COMPLETED.code === request.status.code &&
                                HelperUtils.hasOperationInCurrentLaboratory(CaseOperation.PRINT)
                        }
                    },
                    showInGlobalLocator: {
                        action: () => this.showInGlobalLocator(this.request.label),
                        enabled: () => !isMultipleSelection
                    }
                })
            }
            return []
        },
        applySideBarFilterModel() {
            if (this.gridApi) {
                this.gridApi.setFilterModel(this.sideBarFilterModel)
                this.gridApi.deselectAll()
                this.showSidePanel = false
            }
        },
        onSideBarClickAddFilter() {
            this.$refs.addFilterModal.show()
        },
        async onSideBarClickUpdateFilter(option) {
            if (isEmpty(this.gridApi.getFilterModel())) {
                this.saveNoFilter()
                return
            }
            const [err] = await this.toCall(registrySideBarStore.updateCustomOption(option, { filterModel: this.gridApi.getFilterModel() }))
            if (err) {
                this.showErrorModalGlobal()
                return
            }
            await registrySideBarStore.loadCustomOptions()
            this.showToastSuccessGlobal(this.$t('global.filterUpdated'))
        },
        async onAddFilterOk(filter) {
            if (isEmpty(this.gridApi.getFilterModel())) {
                this.saveNoFilter()
                return
            }
            const params = {
                label: filter.label,
                filterModel: this.gridApi.getFilterModel()
            }
            await customFilterResource.create(
                this.sideBarState.componentCode,
                params
            )
            await registrySideBarStore.loadCustomOptions()
            this.showToastSuccessGlobal(this.$t('global.filterAdded'))
        },
        async printRequestReport(clickedRequest) {
            const request = this.selectedRegistryRequest ?? clickedRequest
            await this.$refs.printComponent.printRequestReportFromRegistry(request)
        },
        async printPathologyReport(labId, casId, hasCaseStudiesAssociated) {
            let includeAssociated = false
            if (hasCaseStudiesAssociated) {
                includeAssociated =
                    await this.showConfirmationModalGlobal(
                        this.$tc('global.modal.case.viewAssociatedCasesConfirmation'))
            }
            await this.$refs.printComponent.printCaseReportFromRegistry(labId, casId, includeAssociated)
        },
        async printSubrequestLabels(selectedRegistryRequest) {
            const request = selectedRegistryRequest ?? this.selectedRegistryRequest
            await this.$refs.printComponent.printSubrequestReportFromRegistry(
                request.laboratory.labId,
                request.id,
                request.subrequests)
        },
        exportReport(exportType) {
            const columns = this.$_getColumnsToExport(this.gridApi, this.columnApi)
            if (columns && this.gridApi) {
                return registryRequestPrintService.exportTo(
                    this.laboratoryId,
                    this.$tc('global.register'),
                    this.encoder.parseBooleans(this.gridApi.getFilterModel()),
                    GridUtils.getSortValue(this.gridApi.getSortModel()),
                    columns,
                    this.selectedRows.map(selectedRow => selectedRow.id),
                    exportType)
            }
            return null
        }
    }
}
</script>

<style lang="scss">
    // Master detail registry request
    .registry-request-grid .vt-grid {
        height: 100%;
    }

    .registry-request-grid .vt-grid .ag-root-wrapper {
        height: 100%;
    }

    .registry-request-grid .simple-pop-inside {
        width: 80px !important;
    }

    .registry-request-grid .popover-header {
        display: none !important;
    }

    .registry-request-grid .ag-row-focus {
        background: vt-color(grid-row-focus);
    }

    .registry-request-page {
        display: flex;
    }

    .registry-request-grid .sr-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin: 0.5rem;
        flex-shrink: 0;
    }
</style>
